import { useMutation } from '@tanstack/react-query';

import { Membership, MEMBERSHIP_STATUS } from 'src/features/users/utils/types';
import axios from 'src/lib/axios';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { MutationConfig } from 'src/lib/react-query';

const RESOURCE = '/parkings/:parkingId/memberships/:membershipId/';

interface DTO {
    parkingId: string;
    membershipId: string;
    status?: MEMBERSHIP_STATUS;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<Membership> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateParkingMembership };
